var map = {
	"./0.gif": 971,
	"./1.gif": 3250,
	"./2.gif": 733,
	"./3.gif": 5300,
	"./4.gif": 1735,
	"./5.gif": 8926,
	"./6.gif": 3241,
	"./7.gif": 1072,
	"./8.gif": 611
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5670;